import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { handleReset } from "@common/components/helpers/reset";
import { selfExclusionSchema } from "../helpers/validation-schemas/selfExclusionSchema";
import { useHistory } from "react-router-dom";
import {
  getCurrentDateTime,
  getDatePart,
  getTimePart,
} from "../helpers/datetime";

const useSelfExclusion = () => {
  const history = useHistory();
  const methods = useForm({
    resolver: yupResolver(selfExclusionSchema),
    defaultValues: selfExclusionDefaultValues,
    mode: "all",
  });

  const handleBack = () => {
    handleReset(methods.reset);
    history.push("/compliance");
  };

  return {
    methods,
    handleBack,
  };
};
export default useSelfExclusion;

const selfExclusionDefaultValues = {
  date: getDatePart(getCurrentDateTime()),
  time: getTimePart(getCurrentDateTime()),
  selfExclusionTypes: [],
  selfExclusionType: { id: null },
  customerReference: null,
};
